document.addEventListener('DOMContentLoaded', function(){
    const tabs = document.querySelectorAll('.product-tabs__btn');
    const contents = document.querySelectorAll('.product-tabs__content');

    tabs.forEach(tab => {
        tab.addEventListener('click', (evt) => {
            const target = evt.target;
            if ( !target?.id.includes('ProductTabs-') ) return

            const button = target.closest('.product-tabs__btn');
            if ( !!!button ) return

            const contentToShow = document.querySelector(`.product-tabs__content#${ button.id }`)
            if ( !!!contentToShow ) return

            contents.forEach(content => content.classList.add('hidden'))
            tabs.forEach(tab => tab.classList.remove('is-active'))

            contentToShow.classList.remove('hidden')
            button.classList.add('is-active')
        })
    })

    const hasSelected = [...tabs].find(tab => tab.classList.contains('is-active'));
    if (!!!hasSelected) tabs[0]?.click()
})
